const LOCK = "data-lock";
const DISABLE_UNLOCK = "data-disable-unlock";
const LOCK_CLASSNAME = "k-page-lock";
export const EVENT_ONLOCK = "onlock";
export const EVENT_ONUNLOCK = "onunlock";

/**@param {HTMLElement} dom */
export function lock(dom) {
  if (!dom) {
    return;
  }
  if (checkIsLock(dom)) {
    return;
  }
  let top = Math.max(
    window.pageYOffset || 0,
    window.scrollY || 0,
    document.documentElement.scrollTop,
    document.body.scrollTop
  );
  dom.classList.add(LOCK_CLASSNAME);
  dom.scrollTop = top;
  dom.setAttribute(LOCK, "1");
  dom.removeAttribute(DISABLE_UNLOCK);
  window.scrollTo(0, 0);
  dom.dispatchEvent(
    new CustomEvent(EVENT_ONLOCK, {
      bubbles: false
    })
  );
}

/**@param {HTMLElement} dom */
export function unlock(dom) {
  if (!dom) {
    return;
  }
  if (!checkIsLock(dom)) {
    return;
  }
  if (checkIsDisableUnlock(dom)) {
    dom.removeAttribute(DISABLE_UNLOCK);
    return;
  }
  let top = dom.scrollTop;
  // dom.style.webkitTransform = "translate3d(0,0,1px)";
  dom.classList.remove(LOCK_CLASSNAME);
  dom.scrollTop = 0;
  dom.removeAttribute(LOCK);
  window.scrollTo(0, top);
  dom.dispatchEvent(
    new CustomEvent(EVENT_ONUNLOCK, {
      bubbles: false
    })
  );
  // dom.style.webkitTransform = "";
}

/**@param {HTMLElement} dom */
export function disableUnlock(dom) {
  dom.setAttribute(DISABLE_UNLOCK, "1");
}

/**@param {HTMLElement} dom */
export function checkIsLock(dom) {
  if (!dom) {
    return false;
  }
  return dom.getAttribute(LOCK) === "1";
}

/**@param {HTMLElement} dom */
export function checkIsDisableUnlock(dom) {
  if (!dom) {
    return false;
  }
  return dom.getAttribute(DISABLE_UNLOCK) === "1";
}

class PageStack {
  list = [];
  get el() {
    return this.list[this.list.length - 1];
  }

  /**@param {HTMLElement} el */
  push(el) {
    this.list.push(el);
  }

  pop() {
    let el = this.list.pop();
    unlock(el);
    return el;
  }

  lock() {
    let el = this.el;
    if (el) lock(el);
  }
  unlock() {
    let el = this.el;
    if (el) unlock(el);
  }
  disableUnlock() {
    let el = this.el;
    if (el) disableUnlock(el);
  }
}

export default new PageStack();
